import styled, { css } from 'styled-components';

const headerCommon = css`
  color: #202432; /* TODO: theme */
  margin: 0;
`;

export const H1 = styled.h1`
  ${headerCommon}
  font-size: 1.5em; /* TODO: theme */
  font-weight: 600; /* TODO: theme */
`;

export const H2 = styled.h2`
  ${headerCommon}
  font-size: 1.25em; /* TODO: theme */
  font-weight: 300; /* TODO: theme */
`;
